import { RouteObject } from "react-router-dom";

import { AuthorizedRoute } from "src/authentication/AuthorizedRoute.tsx";
import { Scope, ScopeResource } from "src/authentication/PermissionsProvider.tsx";
import DynamicViewSchemaProvider from "src/dynamic-view-renderer/DynamicViewSchemaProvider/DynamicViewSchemaProvider.tsx";
import { useT } from "src/internationalization";
import CaseDetailsPage from "src/pages/CaseDetalis/CaseDetailsPage.tsx";

import ErrorBoundary from "../components/Errors/ErrorBoundary";
import CasesPage from "../pages/Cases/CasesPage.tsx";
import RequestsTab from "../pages/Cases/RequestsTab.tsx";

export const useCasesRoutes = (): RouteObject[] => {
  const t = useT();

  return [
    {
      path: "cases",
      element: (
        <AuthorizedRoute
          requiredPermissions={[{ resource: ScopeResource.CASE, scopes: [Scope.VIEW] }]}
          pageTitle={t("page.cases.title")}
        >
          <DynamicViewSchemaProvider>
            <CasesPage />
          </DynamicViewSchemaProvider>
        </AuthorizedRoute>
      ),
      ErrorBoundary: ErrorBoundary,
      children: [
        {
          path: ":code",
          Component: RequestsTab,
          ErrorBoundary: ErrorBoundary,
        },
      ],
    },
    {
      path: "case/:caseTypeCode/:id",
      element: (
        <AuthorizedRoute
          requiredPermissions={[{ resource: ScopeResource.CASE, scopes: [Scope.VIEW] }]}
          pageTitle={t("page.cases.title")}
        >
          <DynamicViewSchemaProvider>
            <CaseDetailsPage />
          </DynamicViewSchemaProvider>
        </AuthorizedRoute>
      ),
      ErrorBoundary: ErrorBoundary,
    },
    {
      path: "case/:caseTypeCode/:id/:code",
      element: (
        <AuthorizedRoute
          requiredPermissions={[{ resource: ScopeResource.CASE, scopes: [Scope.VIEW] }]}
          pageTitle={t("page.cases.title")}
        >
          <DynamicViewSchemaProvider>
            <CaseDetailsPage />
          </DynamicViewSchemaProvider>
        </AuthorizedRoute>
      ),
      ErrorBoundary: ErrorBoundary,
    },
  ];
};
